import { Expose } from "class-transformer";
import { IsBoolean, IsString } from "class-validator";

export class UserRole {
  @Expose()
  @IsString()
  displayRoleName!: string;
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  roleName!: string;
  @Expose()
  @IsBoolean()
  userIsInRole!: boolean;
}
